import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	errorStateContainer: {
		width: '1056px',
		height: '408px',
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.300'),
		alignItems: 'center',
		justifyContent: 'center',
		opacity: 1,
		paddingTop: token('space.600'),
		paddingRight: token('space.600'),
		paddingBottom: token('space.600'),
		paddingLeft: token('space.600'),
	},
});

export const ErrorStateContainer = ({
	children,
	testId,
}: {
	children: React.ReactNode;
	testId?: string;
}): React.JSX.Element => {
	return (
		<Box xcss={styles.errorStateContainer} testId={testId}>
			{children}
		</Box>
	);
};
